import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Input from '../../components/ui/Input';
import { useAuth } from '../../contexts/AuthContext';
import { userHomePath } from '../../support/accountFunction';
import { getApiErrorMessage } from '../../utils/errors';

function SelectAccount() {
  const navigate = useNavigate();
  const { memberships, switchAccount, createWorkspace, user } = useAuth();
  const [workspaceName, setWorkspaceName] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const hasNoMemberships = memberships.length === 0;

  const handleSelect = async (accountId) => {
    await switchAccount(accountId);
    navigate(userHomePath(), { replace: true });
  };

  const handleCreateWorkspace = async (event) => {
    event.preventDefault();
    setError('');
    setIsSubmitting(true);

    try {
      await createWorkspace(workspaceName);
      navigate(userHomePath(), { replace: true });
    } catch (err) {
      setError(getApiErrorMessage(err, 'Não foi possível criar o workspace.'));
    } finally {
      setIsSubmitting(false);
    }
  };

  if (hasNoMemberships) {
    return (
      <div className="surface-card p-8 shadow-card-md max-w-lg mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-content-primary mb-2">Crie seu workspace</h1>
          <p className="text-content-muted text-sm">
            Olá, {user?.name}. Você ainda não tem acesso a nenhum workspace. Crie um para começar
            ou aguarde um convite por e-mail.
          </p>
        </div>

        <form onSubmit={handleCreateWorkspace} className="space-y-5">
          <Input
            id="workspace_name"
            label="Nome do workspace"
            value={workspaceName}
            onChange={(e) => setWorkspaceName(e.target.value)}
            placeholder="Ex.: Minha Empresa"
            required
            autoFocus
            error={error}
          />

          <button
            type="submit"
            disabled={isSubmitting}
            className="btn-primary w-full disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSubmitting ? 'Criando...' : 'Criar workspace'}
          </button>
        </form>
      </div>
    );
  }

  return (
    <div className="surface-card p-8 shadow-card-md max-w-lg mx-auto">
      <div className="text-center mb-8">
        <h1 className="text-2xl font-bold text-content-primary mb-2">Escolha um workspace</h1>
        <p className="text-content-muted text-sm">
          Olá, {user?.name}. Selecione qual workspace deseja acessar.
        </p>
      </div>

      <div className="space-y-3">
        {memberships.map((membership) => (
          <button
            key={membership.account_id}
            type="button"
            onClick={() => handleSelect(membership.account_id)}
            className="w-full text-left rounded-lg border border-slate-200 px-4 py-3 hover:border-forge-300 hover:bg-forge-50 transition-colors"
          >
            <div className="font-medium text-content-primary">
              {membership.account?.name || 'Workspace'}
            </div>
            <div className="text-sm text-content-muted capitalize">{membership.role}</div>
          </button>
        ))}
      </div>
    </div>
  );
}

export default SelectAccount;
